import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import moment from 'moment';

import Button, { BUTTON_TYPES } from '../Button';
import InfoItem from '../InfoItem';
import TitleForm from '../TitleForm';

import { FORMAT_DATE } from '../../constants/Configs';
import { CommonStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
const PassportViewer = ({ profile, onEditPress, isUpdateAllowed = true }) => {
  const { tKey } = useComponentTKey('PassportForm');
  const { t } = useTranslation(i18nNS.me);
  const [info, setInfo] = useState({
    gender: '',
    birthDate: '',
    redressNumber: '',
    KnownTraveler: '',
    country: '',
    passportNumber: '',
    passportName: '',
    issuingCountry: '',
    expirationDate: '',
    passportNumber2: '',
    passportName2: '',
    issuingCountry2: '',
    expirationDate2: '',
  });

  useEffect(() => {
    if (profile && Object.keys(profile).length > 0) {
      const birthDate = profile.BirthDate ? moment(profile.BirthDate).format(FORMAT_DATE) : '';
      const expirationDate = profile.PassportExpiry1
        ? moment(profile.PassportExpiry1).format(FORMAT_DATE)
        : '';
      const expirationDate2 = profile.PassportExpiry2
        ? moment(profile.PassportExpiry2).format(FORMAT_DATE)
        : '';

      setInfo({
        ...profile,
        gender: profile.Gender,
        birthDate: birthDate,
        redressNumber: profile.TSARedressNum,
        knownTraveler: profile.TSAKnownTravelerNum,
        country: profile.TSAKnownTravelerCountry,
        passportNumber: profile.PassportNum1,
        passportName: profile.NameOnPassport,
        issuingCountry: profile.PassportCountry1,
        expirationDate: expirationDate,
        passportNumber2: profile.PassportNum2,
        passportName2: profile.NameOnPassport2,
        issuingCountry2: profile.PassportCountry2,
        expirationDate2: expirationDate2,
      });
    }
  }, [profile]);

  return (
    <View style={CommonStyles.p3}>
      {isUpdateAllowed && (
        <Button
          label={t(tKey('EditPassport'))}
          type={BUTTON_TYPES.TEXT}
          iconName="edit"
          onPress={onEditPress}
        />
      )}
      <InfoItem label={t(tKey('Gender'))} value={info.gender} />
      <InfoItem label={t(tKey('DOB'))} value={info.birthDate} />
      <InfoItem label={t(tKey('RedressNumber'))} value={info.redressNumber} />
      <InfoItem label={t(tKey('KnownTraveler'))} value={info.knownTraveler} />
      <InfoItem label={t(tKey('ApplicableCountry'))} value={info.country} />
      <TitleForm title={t(tKey('PassportInformation'))} />
      <InfoItem label={t(tKey('Passport#'))} value={info.passportNumber} />
      <InfoItem label={t(tKey('NameOnPassport'))} value={info.passportName} />
      <InfoItem label={t(tKey('IssuingCountry'))} value={info.issuingCountry} />
      <InfoItem label={t(tKey('ExpirationDate'))} value={info.expirationDate} />
      <TitleForm />
      <InfoItem label={t(tKey('Passport#'))} value={info.passportNumber2} />
      <InfoItem label={t(tKey('NameOnPassport'))} value={info.passportName2} />
      <InfoItem label={t(tKey('IssuingCountry'))} value={info.issuingCountry2} />
      <InfoItem label={t(tKey('ExpirationDate'))} value={info.expirationDate2} />
    </View>
  );
};

export default PassportViewer;
